import styled from "styled-components";

export default styled.img`
  width: ${(props) => (props.width ? props.width : "100%")};
  height: ${(props) => (props.height ? props.height : "100%")};
  display: block;
  margin: auto;
`;
